import ApplicationController from './application_controller'

export default class extends ApplicationController {

	static targets = [
		'item',
		'emptyMessage',
	]

	connect() {
		this.emptyMessageElement = this.emptyMessageTarget.cloneNode(true)
		this.emptyMessageTarget.remove()
		this.updateEmptyMessage()
		this.connected = true
	}

	itemTargetConnected(_element) {
		this.debounce(() => {
			if (this.connected) { this.updateEmptyMessage() }
		}, 10)()
	}

	itemTargetDisconnected() {
		this.debounce(() => {
			if (this.connected) { this.updateEmptyMessage() }
		}, 10)()
	}

	itemMarkedForDestroy() {
		if (this.connected) { this.updateEmptyMessage() }
	}

	hasItems() {
		return this.itemTargets.some(item => !item.classList.contains('d-none'))
	}

	updateEmptyMessage() {
		if (this.hasItems()) {
			if (this.hasEmptyMessageTarget) { this.emptyMessageTarget.remove() }
		} else {
			if (!this.hasEmptyMessageTarget) { this.element.append(this.emptyMessageElement) }
		}
	}

	debounce(func, wait) {
		let timeout
		return function executedFunction(...args) {
			const later = () => {
				clearTimeout(timeout)
				func(...args)
			}
			clearTimeout(timeout)
			timeout = setTimeout(later, wait);
		}
	}
}

